import * as http from 'util/elemental_axios_client.js';

/** Make GET request to fetch dog picture. quantity is optional */
export const getErrors = () =>
    http.get('/api/v1/utils/api_key_check');
